import React from 'react';

const SvgComponent = (props) => (
  <svg width={ 18.5 } height={ 31.5 } { ...props }>
    <path stroke="#000" fill="none" d="M1.993.498L17.502 15.5 1.993 30.501" />
  </svg>
);

export default SvgComponent;
